'use client';

import { useRef } from 'react';
import type { ArticleStoreProps } from './articleStore';
import { useArticleStore } from './articleStore';

function ArticleStoreInitializer(storeProps: Partial<ArticleStoreProps>) {
    const initialized = useRef(false);

    if (!initialized.current) {
        useArticleStore.setState(storeProps);
        initialized.current = true;
    }

    return null;
}

export default ArticleStoreInitializer;
